export default __webpack_public_path__ + "static/media/s-12.29902952.jpg";